module.exports = "<p>\r\n  awsop-lab5 works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab5/awsop-lab5.component.html
// module id = ./src/app/course/labs/awsop/awsop-lab5/awsop-lab5.component.html
// module chunks = main